<template>
  <div class="page-order-detail">
    <div class="title title-left">{{$t('page.order_detail.title')}}</div>
    <template v-if="mOrder.id>0">
      <Card :bordered="false" :shadow="false">
        <MyOrder :order="mOrder" detail/>
      </Card>

      <template v-if="mOrder.sns && mOrder.sns.length>0">
        <hr class="my-hr">
        <div class="title title-left">{{$t('order.startup_sn')}}</div>
        <Card :bordered="false" :shadow="false">
          <div class="sn-info" v-for="sn in mOrder.sns" :key="sn.id">
            <div class="sn" :class="{'sn-bind':sn.user}">{{ sn.sn|addPad }}</div>
            <div class="bind-info"
                 v-if="sn.user">{{$t('order.bind_sn')}}{{ sn.user.state_code }} {{ sn.user.mobile }}</div>
          </div>
        </Card>
      </template>

      <!-- 收件信息 -->
      <template v-if="mOrder.receive_name">
        <hr class="my-hr">
        <div class="title title-left">{{$t('order.receive_info')}}</div>
        <Card :bordered="false" :shadow="false">
          <div class="receive_info">
            <div>{{$t('order.label_receive_name')}}
              {{mOrder.receive_name}}
            </div>
            <div>{{$t('order.label_receive_tel')}}
              +{{mOrder.receive_tel}}
            </div>
            <div>{{$t('order.label_transport_way')}}
              <span v-if="mOrder.express">{{mOrder.express.name}}</span>
              <span v-else>{{$t('order.way_logistics')}}</span>
            </div>
            <div v-if="mOrder.delivery_no">
              <div>{{$t('order.label_delivery_no')}}{{mOrder.delivery_no}}</div>
            </div>
            <div v-if="mOrder.receive_area">{{$t('order.label_receive_addr')}}
              {{mOrder.receive_area|removePad}}{{mOrder.receive_address }}
            </div>
            <div v-if="mOrder.postcode">{{$t('addr.postcode')}}：
              {{mOrder.postcode }}
            </div>
          </div>
        </Card>
      </template>

      <!-- 发票资讯 -->
        <hr class="my-hr">
        <div class="title title-left">{{$t('invoice.title')}}</div>
        <Card :bordered="false" :shadow="false">
          <div class="invoice_info">
            <div v-if="mOrder.invoice && mOrder.invoice.tax_id">
              <div>{{$t('invoice.company_invoice')}}</div>
              <div>{{$t('invoice.tax_id')}}：{{mOrder.invoice.tax_id}}</div>
              <div>{{$t('invoice.invoice_head')}}：{{mOrder.invoice.invoice_head}}</div>
            </div>
            <div v-else>
              {{$t('invoice.personal_invoice')}}
            </div>
          </div>
        </Card>

      <!-- 订单时间 -->
      <hr class="my-hr">
      <div class="title title-left">{{$t('order.label_time')}}</div>
      <Card :bordered="false" :shadow="false">
        <div class="order-time">
          <div>
            <div>{{$t('order.add_time')}}</div>
            <div>{{ (mOrder.created_at * 1000)|dateformat }}</div>
          </div>
          <div v-if="mOrder.pay_time">
            <div>{{$t('order.pay_time')}}</div>
            <div>{{ (mOrder.pay_time * 1000)|dateformat }}</div>
          </div>
          <div v-if="mOrder.complete_time">
            <div>{{$t('order.complete_time')}}</div>
            <div>{{ (mOrder.complete_time * 1000)|dateformat }}</div>
          </div>
        </div>
      </Card>

      <!-- 退货信息 -->
      <template v-if="mOrder.refund">
        <hr class="my-hr">
        <div class="title title-left">{{$t('order.refund_info')}}</div>
        <Card :bordered="false" :shadow="false">
          <div class="receive_info">
            <div>{{$t('order.label_refund_reason')}}
              {{mOrder.refund.reason}}
            </div>
            <div>{{$t('order.label_refund_user')}}
              +{{mOrder.refund.user}}
            </div>
            <div>{{$t('order.label_refund_addr')}}
              {{mOrder.refund.address}}
            </div>
            <div>{{$t('order.label_refund_tel')}}
              {{mOrder.refund.tel}}
            </div>
            <div>{{$t('order.label_refund_account')}}
              {{mOrder.refund.bank_user}}&nbsp;
              {{mOrder.refund.bank_code}}&nbsp;
              {{mOrder.refund.bank_name}}&nbsp;
              {{mOrder.refund.bank_account}}
            </div>
          </div>
        </Card>

        <!-- 拒绝原因 -->
        <template v-if="mOrder.refund.refuse">
          <hr class="my-hr">
          <div class="title title-left">{{$t('order.refund_refuse_reason')}}</div>
          <Card :bordered="false" :shadow="false">
            <div class="receive_info">
              <div>{{mOrder.refund.refuse}}
              </div>
            </div>
          </Card>
        </template>

        <hr class="my-hr">
        <div class="title title-left">{{$t('order.refund_time')}}</div>
        <Card :bordered="false" :shadow="false">
          <div class="receive_info">
            <div>{{$t('order.label_refund_time_request')}}
              {{ (mOrder.refund.request_time * 1000)|dateformat }}
            </div>
          </div>
          <div class="receive_info" v-if="mOrder.refund.accept_time">
            <div>{{$t('order.label_refund_time_accept')}}
              {{ (mOrder.refund.accept_time * 1000)|dateformat }}
            </div>
          </div>
          <div class="receive_info" v-if="mOrder.refund.refuse_time">
            <div>{{$t('order.label_refund_time_refuse')}}
              {{ (mOrder.refund.refuse_time * 1000)|dateformat }}
            </div>
          </div>
        </Card>
      </template>

      <!-- 备注 -->
      <template v-if="canRemark">
        <div class="title title-left remark-title">{{$t('page.order_detail.label_remark')}}</div>
        <div class="remark-input">
          <Input v-model="mRemark" maxlength="200" show-word-limit
                 type="textarea"/>
          <Button class="button" style="margin-left: 5px;"
                  @click="onRemarkPost">{{$t('page.order_detail.btn_remark')}}</Button>
        </div>
      </template>
      <div v-if="mRemarkErr" class="remark-err">{{mRemarkErr}}</div>

      <div v-for="(remark, ri) in mRemarkList" :key="ri">
        <div class="remark-header">
          <div v-if="remark.type==0" style="flex-grow: 1;">
            <Avatar :src="$store.getters.userHead"
                    @on-error="$store.commit('clearHead')"></Avatar>
            {{userName}}
          </div>
          <div v-else style="flex-grow: 1;">
            <Avatar :src="service_head"></Avatar>
            {{$t('page.order_detail.service_name')}}
          </div>
          <div>{{ (remark.created_at * 1000)|dateformat }}</div>
        </div>
        <div class="remark-content">{{remark.message}}</div>
      </div>

      <div>
        <div :style="{height:footerButtonHeight+'px'}"></div>
        <div ref="bottomButtons" class="bottom-buttons bottom-buttons-fixed">
          <template v-if="mOrder.status === statusList.wait_buyer_confirm_goods">
            <div class="complete-label">{{$t('order.label_complete_order')}}</div>
            <Button class="btn btn-ok" long
                    @click.stop="onCompleteOrder">{{ $t('page.order_detail.btn_complete') }}
            </Button>
          </template>
          <template v-if="canPay">
            <Button class="btn btn-ok" long
                    @click.stop="onPay">{{ $t('common.btn_pay') }}
            </Button>
            <Button v-if="canRebuy" class="btn" long
                    @click.stop="onRebuy">{{ $t('page.order_detail.btn_rebuy') }}
            </Button>
          </template>
          <Button v-else-if="canRebuy" class="btn btn-ok" long
                  @click.stop="onRebuy">{{ $t('page.order_detail.btn_rebuy') }}
          </Button>
          <Button v-if="canRefund" class="btn" long
                  @click.stop="onRefund">{{ $t('page.order_detail.btn_refund') }}
          </Button>
          <Button class="btn" long
                  @click.stop="$router.go(-1)">{{ $t('common.btn_back') }}
          </Button>
        </div>
      </div>
    </template>
    <p v-else-if="!loading"
       class="no-content-tip">{{$t('order.no_order')}}</p>
  </div>
</template>
<script>
    import { httpGet, httpGetParams, httpPost, CancelToken } from '@/api/http';
    import Setting from '@/setting';
    import MyOrder from '@/components/MyOrder';
    import common from '@/mixins/common';

    export default {
        components: {
            MyOrder
        },
        mixins: [common],
        data () {
            return {
                loading: false,
                mOrder: {
                    id: 0
                },
                form: {
                },
                service_head: require('@/assets/service.png'),
                mRemark: '',
                mRemarkList: [],
                mRemarkErr: null,
                statusList: Setting.order_list
            }
        },
        filters: {
            addPad: function (str) {
                return str.replace(/(.{5})/g, '$1 ')
            },
            removePad: function (str) {
                return str.replace(/\s+/g, '')
            }
        },
        computed: {
            canRebuy () {
                switch (this.mOrder.status) {
                case this.statusList.err_status:
                    return false;
                }
                return true;
            },
            canPay () {
                return this.mOrder.allow_pay;
            },
            canRefund () {
                switch (this.mOrder.status) {
                case this.statusList.trade_evaluated:
                case this.statusList.trade_complete:
                    // return true;
                    break; // todo: 暂时去掉退货功能@20220720
                }
                return false;
            },
            canRemark () {
                switch (this.mOrder.status) {
                case this.statusList.trade_closed:
                    return false;
                }
                return true;
            },
            userName () {
                const user = this.$store.state.userinfo;
                return user.nick || user.uname;
            }
        },
        methods: {
            getData (id) {
                if (!id) {
                    // 参数不存在
                    id = this.$store.state.pay_order_id;
                    if (!id) {
                        return;
                    }
                }
                if (this.cancel) {
                    this.cancel();
                    this.cancel = null;
                }
                this.loading = true;
                this.$Spin.show();
                httpGetParams('/v1/mall/order/' + id, this.form, new CancelToken((c) => {
                    this.cancel = c
                })).then(res => {
                    this.mOrder = res;
                    this.getRemarkList();
                }).catch(() => {
                }).finally(() => {
                    this.loading = false;
                    this.setFooterButtonPad();
                    this.$Spin.hide();
                    this.cancel = null;
                });
            },
            onRebuy () {
                this.loading = true
                const order = this.$router.face.order();
                for (const i in this.mOrder.items) {
                    const item = this.mOrder.items[i];
                    order.append(item.goods_id, item.num);
                }
                order.go();
                this.loading = false;
            },
            onRefund () {
                this.$router.push({
                    name: 'OrderRefund',
                    params: {
                        order: this.mOrder
                    }
                });
            },
            onPay () {
                this.loading = true;
                this.$Spin.show();
                this.$router.face.pay(this.mOrder);
            },
            onCompleteOrder () {
                this.$Spin.show();
                httpPost('/v1/mall/order/' + this.mOrder.id + '/confirm', this.form).then(res => {
                    this.$set(this.mOrder, 'status', this.statusList.trade_complete);
                }).finally(() => {
                    this.$Spin.hide();
                });
            },
            getRemarkList () {
                this.mRemarkErr = null;
                httpGet('/v1/mall/order/' + this.mOrder.id + '/messages', null, { ignores: [] }).then(res => {
                    this.mRemarkList = res.data;
                }).catch((err) => {
                    this.mRemarkErr = err;
                });
            },
            onRemarkPost () {
                this.loading = true;
                this.$Spin.show();
                httpPost('/v1/mall/order/' + this.mOrder.id + '/message', {
                    message: this.mRemark
                }).then(res => {
                    this.mRemark = '';
                    this.mRemarkList.push(res);
                    this.$nextTick(() => {
                        window.scrollTo(0, document.body.scrollHeight);
                    });
                }).catch(() => {
                }).finally(() => {
                    this.loading = false;
                    this.$Spin.hide();
                });
            }
        },
        created () {
            this.getData(this.$route.query.id);
        },
        beforeDestroy () {
            if (this.cancel) {
                this.cancel();
                this.cancel = null;
            }
        }
    }
</script>

<style lang="scss">
  .page-order-detail {
    .sn-info{
      margin: 10px 0;
      .sn{
        font-size: 24px;
        font-weight: bold;
        background: #f5f5f5;
        text-align: center;
        padding: 5px;
        &-bind{
          color: #FF9900;
          background: #f0fddb;
        }
      }
      .bind-info{
        text-align: right;
      }
    }
    .receive_info {
      padding: 0 10px;
      &>div{
        line-height: 200%;
      }
    }

    .invoice_info{
      padding: 0 10px;
      &>div{
        line-height: 200%;
      }
    }

    .bottom-padding{
      padding-bottom: 50px;
    }
    .order-time{
      padding: 0 10px;
      &>div{
        display: flex;
        align-items: center;
        line-height: 120%;

        &>div:first-child{
          min-width: 100px;
        }
        margin-bottom: 10px;
      }
    }

    .complete-label{
      text-align: left;
      font-size: .9rem;
    }

    .remark-title {
      margin: 10px 8px 0 8px;
      background-color: #c6c6c6;
    }
    .remark-input {
      margin: 0px 8px 5px 8px;
      background-color: #dcdcdc;
      padding: 8px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .remark-err {
      margin: 0px 8px;
      color: #ff0606;
      font-size: xx-small;
    }
    .remark-header {
      margin: 0px 8px;
      background-color: #c6c6c6;
      padding: 5px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .remark-content {
      margin: 0px 8px 2px 8px;
      background-color: #dcdcdc;
      padding: 5px;
    }
  }
</style>
